export const posthogConfig = {
  apiKey: process.env.REACT_APP_PUBLIC_POSTHOG_KEY,
  apiHost: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};
